import React, { useState, useEffect } from "react";
import Select from 'react-select';
import { getOptionObject } from '../../../js/helper';
import search from '../../../image/search.svg'

const dropdownStyle = {
  control: (provided) => ({
    ...provided,
    cursor: "pointer", // Ensure the dropdown has pointer cursor
    fontSize: "14px",
    padding: "0px"
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0px 4px", // Reduce padding inside the selected value area
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    cursor: "pointer", // Ensure options have pointer cursor
    backgroundColor: state.isSelected ? "var(--primary-color)" : "#fff",
    "&:hover": {
      backgroundColor: "#beb1f7",
    },
  }),
};

const MonthYearSelector = ({ startYear, startMonth, filterSubmit,loading }) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // Month is 0-based

  const [selectedYear, setSelectedYear] = useState(getOptionObject(currentYear,"y"));
  const [selectedMonth, setSelectedMonth] = useState(getOptionObject(currentMonth));
  const [availableMonths, setAvailableMonths] = useState([]);

  // Generate years from startYear to currentYear
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => getOptionObject(startYear + i,"y"));

  // Function to generate months based on the selected year
  useEffect(() => {
    let months = [];

    if (selectedYear.value === startYear) {
      // If it's the starting year, show months from startMonth
      months = Array.from({ length: 12 - startMonth + 1 }, (_, i) => getOptionObject(startMonth + i));
    } else if (selectedYear.value === currentYear) {
      // If it's the current year, show months up to the current month
      months = Array.from({ length: currentMonth }, (_, i) => getOptionObject(1 + i));
    } else {
      // Show all months for intermediate years
      months = Array.from({ length: 12 }, (_, i) => getOptionObject(1 + i));
    }

    setAvailableMonths(months);

    // Ensure selectedMonth is within the valid range
    if (!months.find(o => o.value === selectedMonth.value)) {
      setSelectedMonth(months[0]);
    }
  }, [selectedYear, startYear, startMonth, currentYear, currentMonth]);

  return (
    <form>
      <div className="row filter-month-year justify-content-start m-0">
        <div className="filter-select mb-2 mt-2">
          <label className="form-label">Year</label>
          <Select
            id="yearFilter"
            defaultValue={selectedYear}
            onChange={(selectedYear) => {setSelectedYear(selectedYear)}}
            options={years} 
            styles={dropdownStyle}
          />
        </div>
        <div className="filter-select mb-2 mt-2">
          <label className="form-label"> Month </label>
          <Select
            id="monthFilter"
            defaultValue={selectedMonth}
            value={selectedMonth} 
            onChange={(selectedMonth) => setSelectedMonth(selectedMonth)} 
            options={availableMonths}
            styles={dropdownStyle}
          />
        </div>
        <span className="search-icon mb-2 mt-2">
          <label className="form-label">&nbsp;</label>
          <div className={loading? "loading-icon":""} onClick={()=>filterSubmit(selectedMonth,selectedYear)} disabled={loading}><img alt="search-icon" src={search} width={23} height={23}/></div>
        </span>
      </div>
    </form>
  );
};

export default MonthYearSelector;